/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
import scrollLock from './functions/_scrollLock.js' // スクロールロック
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper, Thumbs } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination, Thumbs]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

//
//  ##        ###    ##     ##   ####    ##   ##    ###     ####    #####
//  ##       ## ##   ####   ##  ##       ##   ##   ## ##   ##       ##
//  ##      ##   ##  ##  ## ##  ##  ###  ##   ##  ##   ##  ##  ###  #####
//  ##      #######  ##    ###  ##   ##  ##   ##  #######  ##   ##  ##
//  ######  ##   ##  ##     ##   ####     #####   ##   ##   ####    #####
//
let currentLang = $('#lang').val()

window.addEventListener('load', function () {
  var topMvSlide = new Swiper('#topMvSlide', {
    effect: 'fade',
    loop: true, // 無限ループさせる
    speed: 3000,
    loopAdditionalSlides: 1,
    slidesPerView: 1,
    allowTouchMove: false,
    preventClicks: true,
    preventClicksPropagation: true,
    autoplay: {
      // 自動再生
      delay: 5500,
    },
    pagination: {
      el: '.swiper-pagination', // ページネーション要素のクラス
      clickable: true, // クリックによるスライド切り替えを有効にする
      type: 'bullets', // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    },
  })
  var itemSlide = new Swiper('#itemSlide', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
    pagination: {
      el: '.swiper-pagination', // ページネーション要素のクラス
      clickable: true, // クリックによるスライド切り替えを有効にする
      type: 'bullets', // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    },

    navigation: {
      nextEl: '.swiper-button-next', // 「次へ」ボタン要素のクラス
      prevEl: '.swiper-button-prev', // 「前へ」ボタン要素のクラス
    },
  })
  var topicSlide = new Swiper('#topicsSlide', {
    slidesPerView: 'auto',
    spaceBetween: 25,
    centeredSlides: true,
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 3,
        centeredSlides: false,
      },
    },
    autoplay: {
      // オートオプション
      delay: 3000, // 待機時間
      disableOnInteraction: false, // 操作されたらオート解除
    },
    pagination: {
      el: '.topics-pagination', // ページネーション要素のクラス
      clickable: true, // クリックによるスライド切り替えを有効にする
      type: 'bullets', // 'bullets'（デフォルト） | 'fraction' | 'progressbar'
    },

    navigation: {
      nextEl: '.topics-button-next', // 「次へ」ボタン要素のクラス
      prevEl: '.topics-button-prev', // 「前へ」ボタン要素のクラス
    },
  })

  var topNewsSlide = new Swiper('#topNewsSlide', {
    slidesPerView: 3,
    centeredSlides: false,
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next-news', // 「次へ」ボタン要素のクラス
      prevEl: '.swiper-button-prev-news', // 「前へ」ボタン要素のクラス
    },
    breakpoints: {
      768: {
        spaceBetween: 20,
        slidesPerView: 'auto',
        centeredSlides: false,
      },
    },
  })

  const slideItem = document.getElementById('singleProSlide')
  const sliderName = 'singleProSlide'
  const thumbClass = 'SinglePro__thumbnail--img'
  const mytap = window.ontouchstart === null ? 'touchstart' : 'click'

  var singleProSlide = new Swiper('#singleProSlide', {
    loop: true, // 無限ループさせる
    slidesPerView: 1,
    centeredSlides: true,

    navigation: {
      nextEl: '.swiper-button-next', // 「次へ」ボタン要素のクラス
      prevEl: '.swiper-button-prev', // 「前へ」ボタン要素のクラス
    },
    pagination: {
      el: '.thumblist',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        const slides = swiper.slides
        let html = ''
        for (let i = 1; i <= total; i++) {
          if (current === i) {
            html = html + `<div class="${thumbClass} current" data-slideto="${i}">${slides[i].innerHTML}</div>`
          } else {
            html = html + `<div class="${thumbClass}" data-slideto="  ${i}">${slides[i].innerHTML}</div>`
          }
        }
        return html
      },
    },
  })

  const clickThumbs = () => {
    const thumbItems = document.getElementsByClassName(thumbClass)
    for (let i = 0; i < thumbItems.length; i++) {
      thumbItems[i].addEventListener(
        mytap,
        (e) => {
          let index = e.currentTarget.dataset.slideto
          singleProSlide.slideTo(index, 1500, true)
        },
        false
      )
    }
  }

  clickThumbs()
  singleProSlide.on('slideChange', clickThumbs)
})

$(function () {
  // sessionStorage.setItem('banner-delete', null)

  if (sessionStorage.getItem('banner-delete') === null) {
    $(window).scroll(function () {
      let wh = $(window).height()
      let Off
      if ($('#top').length) {
        Off = $('.topCopy').offset().top
      } else {
        Off = 0
      }
      let scroll = $(this).scrollTop()
      if (scroll >= Off) {
        $('.js-banner').addClass('show')
      } else {
        $('.js-banner').removeClass('show')
      }
    })
    $('.js-banner-close').click(function () {
      $('.js-banner').removeClass('show')
      $('.js-banner').hide()
      sessionStorage.setItem('banner-delete', 'on')
    })
  }
})

// sessionStorage.clear()

let set_position = 0
window.addEventListener('scroll', function () {
  if (document.documentElement.scrollTop <= 0) {
    $('.header').addClass('show')
  } else if (set_position < document.documentElement.scrollTop) {
    $('.header').removeClass('show')
    if (!$('.header').hasClass('hide')) {
      $('.header').addClass('hide')
    }
  } else {
    $('.header').removeClass('hide')
    if (!$('.header').hasClass('show')) {
      $('.header').addClass('show')
    }
  }

  // if (document.documentElement.scrollTop < 0) {
  // }

  set_position = document.documentElement.scrollTop
})

// レビュー色付け
$('.star5_rating').each(function (index, e) {
  //　レビューの値
  let starRate = $(this).data('rate')
  //　0.5で割り切れない場合
  if (starRate > 0) {
    //　widthの値
    let widthRate = Math.round((starRate / 5) * 100, 2)
    //　追加する疑似要素（星のレビュー値のdata-rate値、widthを設定する
    let css = '.star5_rating[data-rate="' + starRate + '"]:after{width:' + widthRate + '%;}'

    //　style要素を作成してCSSを設定
    let style = $('<style>')
    style.text(css)
    //　style要素を全体に追加
    $('body').append(style)
  } else {
    let css = '.star5_rating[data-rate="0"]:after{width:0%;}'
    let style = $('<style>')
    style.text(css)
    //　style要素を全体に追加
    $('body').append(style)
  }
})

// 製品詳細購入タイプチェック制御
$(function () {
  $('.js-type-check').on('click', function () {
    if ($(this).prop('checked')) {
      // 一旦全てをクリアして再チェックする
      $('.js-type-check').prop('checked', false)
      $(this).prop('checked', true)
    }
  })
})

$(function () {
  if ($('#member_pref').length) {
    document.getElementById('member_pref').innerHTML = document
      .getElementById('member_pref')
      .innerHTML.replace(/Prefecture/g, '')
  }
  if ($('#delivery_pref').length) {
    document.getElementById('delivery_pref').innerHTML = document
      .getElementById('delivery_pref')
      .innerHTML.replace(/Prefecture/g, '')
  }
  if ($('#customer_pref').length) {
    document.getElementById('customer_pref').innerHTML = document
      .getElementById('customer_pref')
      .innerHTML.replace(/Prefecture/g, '')
  }
})

$('input[name="purchase-type"]').change(function () {
  let type = $(this).val()
  $('.js-purchase-btn').removeClass('show')
  $('.js-teiki-period').removeClass('show')
  $('.js-purchase-' + type + '-btn').addClass('show')
  $('.js-quantity').removeClass('show')
  $('.js-quantity-' + type).addClass('show')
  if (type === 'teiki') {
    $('.js-teiki-period').addClass('show')
    $('.js-purchase-btn-30').addClass('show')
  }
})

$('input[name="purchase-period"]').change(function () {
  let period = $(this).val()
  $('.js-purchase-btn').removeClass('show')
  $('.js-purchase-btn-' + period).addClass('show')
})

$('input[name="purchase-teiki-period"]').change(function () {
  let period = $(this).val()
  $('.js-purchase-btn-teiki').removeClass('show')
  $('.js-purchase-teiki-btn-' + period).addClass('show')
})

$(function () {
  $('.js-review-open').on('click', function () {
    $('.js-review-modal').addClass('show')
  })
})

// レビューモーダル
$(function () {
  let close = $('.js-modal-close')
  let container = $('.js-modal-open').on('click', function () {
    let href = $(this).attr('href')
    $('.js-modal-' + href).addClass('active')
    $('#overlay').addClass('active')
    $('#overlay').addClass('z-index')
    scrollLock('body', '#overlay')

    return false
  })

  $('.js-modal-close').on('click', function () {
    $('.js-modal').removeClass('active')
    $('#overlay').removeClass('active')
    scrollLock('body', '#overlay')
    $('#gNav-open').removeClass('active')
    $('#overlay').removeClass('z-index')
    $('#gNav').removeClass('active')
    return false
  })
})

$('.js-acc').on('click', function () {
  $(this).toggleClass('open')
  $(this).next().slideToggle()
})

if (currentLang === 'en') {
  $('.to_customerinfo_button').val('To proceed with the purchase')
  $('.checkout_button').val('Confirm order')
  $('.to_deliveryinfo_button').val('Proceed without Registration')
  $('.to_reganddeliveryinfo_button').val('Proceed with Registration')
  $('.delButton').val('×Delete')
  $('.use_coupon_button').val('Apply')
  $('.back_to_delivery_button').val('Go back')
  $("input[name='back']").val('Go back my page')
} else {
  $('.to_customerinfo_button').val('ご購入手続きへ')
  $('.checkout_button').val('注文を確定する')
  $('.to_deliveryinfo_button').val('会員登録せずに次へ')
  $('.delButton').val('×削除する')
}

$('.js-pro-open').on('click', function () {
  $(this).next('.js-pro-content').slideToggle()
  $(this).toggleClass('open')
})

$(function () {
  $(window).scroll(function () {
    let wh = $(window).height()
    let Off
    Off = $('.footer').offset().top
    let scroll = $(this).scrollTop()
    if (scroll >= Off - 1000) {
      $('.js-pro-bottombar').removeClass('show')
    } else {
      $('.js-pro-bottombar').addClass('show')
    }
  })
})

// function pushHideButton() {
//   var txtPass = document.getElementById('loginpass')
//   var btnEye = document.getElementById('loginpass_icon')
//   if (txtPass.type === 'text') {
//     txtPass.type = 'password'
//     $('#btnEye').removeClass('show')
//   } else {
//     txtPass.type = 'text'
//     btnEye.className = 'fa fa-eye-slash'
//     $('#btnEye').removeClass('show')
//   }
// }

// なごみについて動画音量
$('.js-sound_button').click(function () {
  let href = $(this).attr('href')
  if (href === 'sound-off') {
    $('.sound-off').removeClass('show')
    $('.sound-on').addClass('show')
    $('video').prop('muted', false)
  } else {
    $('.sound-off').addClass('show')
    $('.sound-on').removeClass('show')
    $('video').prop('muted', true)
  }
  return false
})

// ゲスト購入時代引き削除
$(function () {
  let val = $('input[name="delivery[delivery_flag]"]:checked').val()
  if (val > 0) {
    $('.payment_1').hide()
  } else {
    $('.payment_1').show()
  }
})

$('input[name="delivery[delivery_flag]"]').change(function () {
  let val = $(this).val()
  if (val > 0) {
    $('.payment_1').hide()
    $('input[name="offer[payment_name]"]').prop('checked', false)
  } else {
    $('.payment_1').show()
  }
})

// ポイントリセットボタン
$('input[name="reset_point"]').on('click', function () {
  $('input[name="offer[usedpoint]"]').val(0)
  $('input[name="use_point"]').trigger('click')
})

let passwordToggle = document.querySelector('.js-password')
if (passwordToggle) {
  passwordToggle.addEventListener('click', (e) => {
    let input = e.currentTarget.previousElementSibling
    let type = input.getAttribute('type')
    input.setAttribute('type', type === 'password' ? 'text' : 'password')
    passwordToggle.classList.toggle('is-visible')
  })
}

let conf_passwordToggle = document.querySelector('.js-password-conf')
if (conf_passwordToggle) {
  conf_passwordToggle.addEventListener('click', (e) => {
    let input = e.currentTarget.previousElementSibling
    let type = input.getAttribute('type')
    input.setAttribute('type', type === 'password' ? 'text' : 'password')
    conf_passwordToggle.classList.toggle('is-visible')
  })
}

$('input[name="定期便の状況変更"]').change(function () {
  if ($(this).val() === '変更') {
    $('select[name="お届けサイクル"]').addClass('validate[required]')
  } else {
    $('select[name="お届けサイクル"]').removeClass('validate[required]')
  }
})
